import { Component, Input, OnInit } from '@angular/core';
import { StringMap } from '@app/utils/string-map';

@Component({
  selector: 'portal-generic-breadcrumb',
  templateUrl: './generic-breadcrumb.component.html',
  styles: [],
  host: {
    class: 'breadcrumb-item',
  },
  standalone: false,
})
export class GenericBreadcrumbComponent implements OnInit {
  @Input()
  route: string;

  @Input()
  routeParams: StringMap<number | string>;

  @Input()
  value: string;

  constructor() {}

  ngOnInit() {}
}
